import PropTypes from 'prop-types';
import {
    Tabs,
    Tab,
    Typography,
    Box,
    IconButton,
    Checkbox
} from '@mui/material';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { Page_Padding } from '../../constants';

const TabForSprints = ({
    tabs,
    value,
    onChange,
    accordionChecks = {},
}) => {
    ;
    const handleNextTab = () => {
        const nextIndex = (value + 1) % tabs.length;
        onChange(null, nextIndex);
    };

    return (
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 5 }}>
            <Tabs
                value={value}
                onChange={onChange}
                indicatorColor="transparent"
                // variant={"scrollable"}
                scrollButtons={"auto"}
                sx={{
                    "& .MuiTabs-flexContainer": {
                        flexWrap: "nowrap",
                    },
                    flexGrow: 1,
                    overflowX: "auto",
                    px: Page_Padding,
                    borderBottom: "1px solid #EEEEEE"

                }}
            >
                {tabs.map((item, index) => (
                    <Tab
                        key={index}
                        sx={{
                            borderBottom: value === index ? "5px solid #DC143C" : "none",
                            py: 0,

                        }}
                        label={
                            <Typography
                                variant='body2'
                                sx={{
                                    color: value === index ? 'red.main' : 'inherit',
                                    fontWeight: 500,
                                    textTransform: "capitalize",
                                    display: 'flex',
                                    alignItems: 'center',
                                }}
                            >
                                {item.label}
                                <Checkbox
                                    checked={item.action?.() || false}
                                    onClick={(e) => e.stopPropagation()}
                                    onChange={(e) => item.onActionChange?.(e.target.checked)}
                                    sx={{
                                        color: 'red.main',
                                        '&.Mui-checked': { color: 'red.main' },
                                        ml: 1,
                                    }}
                                />
                            </Typography>
                        }
                    />
                ))}
            </Tabs>
            <IconButton
                sx={{
                    p: 1, mr: 2,
                    bgcolor: "#FFEAEA",
                    '&:hover': {
                        bgcolor: "#FFEAEA",
                    }
                }}
                onClick={handleNextTab}
            >
                <ArrowForwardIosIcon sx={{ fontSize: "20px", color: "red.main" }} />
            </IconButton>

        </Box>
    );
};

TabForSprints.propTypes = {
    tabs: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string.isRequired,
            component: PropTypes.node,
            action: PropTypes.func,
            onActionChange: PropTypes.func,
        })
    ).isRequired,
    value: PropTypes.number.isRequired,
    onChange: PropTypes.func.isRequired,
    accordionChecks: PropTypes.object,
};

export default TabForSprints;
